import React from "react";
import useAdminPartner from "../hooks/useAdminPartner";
import AdminPartner from "../components/AdminPartner";

const {} = useAdminPartner;

export default function AdminPartnerInterface(props) {
  const { onCancelAction, currentItem, callback, canEdit, onSave } = props;

  return (
    <React.Fragment>
      <AdminPartner
        onCancelAction={onCancelAction}
        currentItem={currentItem}
        callback={callback}
        canEdit={canEdit}
        onSave={onSave}
      />
    </React.Fragment>
  );
}
